module.exports = __webpack_public_path__ + "static/img/63.907b3e81.gif";